import { useRouter } from 'next/router';
import { GALLERY_VIEW } from 'src/listing/constants';

const useGalleryView = (): { isGalleryViewOpen: boolean } => {
  const { asPath } = useRouter();
  const hash = asPath.split('#')[1];

  return {
    isGalleryViewOpen: !!hash && (hash === GALLERY_VIEW || hash.startsWith(`${GALLERY_VIEW}/`)),
  };
};

export default useGalleryView;
